export const AppPermissions = {
  // Main permissions
  /**
   * Softball specific
   */
  PortalAccess: ['SBLD.PortalAccess@SBLD'],
};
